import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import FreightRatesArticle from "./pages/articles/FreightRatesArticle";
import TrainConnectionArticle from "./pages/articles/TrainConnectionArticle";
import CarbonMarketArticle from "./pages/articles/CarbonMarketArticle";
import AWSOutageArticle from "./pages/articles/AWSOutageArticle";
import PortStrikesArticle from "./pages/articles/PortStrikesArticle";
import COSCOBoxshipArticle from "./pages/articles/COSCOBoxshipArticle";
import COSCOShippingArticle from "./pages/articles/COSCOShippingArticle";
import SFExpressUKArticle from "./pages/articles/SFExpressUKArticle";
import ChinaEURailFreightArticle from "./pages/articles/ChinaEURailFreightArticle";
import CMAGMSuezArticle from "./pages/articles/CMAGMSuezArticle";
import UPSKuehneArticle from "./pages/articles/UPSKuehneArticle";
import AmazonNetherlandsArticle from "./pages/articles/AmazonNetherlandsArticle";
import AlibabaLiegeArticle from "./pages/articles/AlibabaLiegeArticle";
import InPostIberiaArticle from "./pages/articles/InPostIberiaArticle";
import EuroCommerceTaxArticle from "./pages/articles/EuroCommerceTaxArticle";
import MonthlyLogisticsInsightsArticle from "./pages/articles/MonthlyLogisticsInsightsArticle";
import FigureBMWArticle from "./pages/articles/FigureBMWArticle";
import EuropeTruckArticle from "./pages/articles/EuropeTruckArticle";
import DHLHalleArticle from "./pages/articles/DHLHalleArticle";
import EFTIDigitalArticle from "./pages/articles/EFTIDigitalArticle";
import EmiratesVTOLArticle from "./pages/articles/EmiratesVTOLArticle";
import AsianInvestmentArticle from "./pages/articles/AsianInvestmentArticle";
import McKinseyAIArticle from "./pages/articles/McKinseyAIArticle";
import BelgiumStrikesArticle from "./pages/articles/BelgiumStrikesArticle";
import PrologisMicrogridArticle from "./pages/articles/PrologisMicrogridArticle";
import RedSeaUpdateArticle from "./pages/articles/RedSeaUpdateArticle";
import ShipEmissionsArticle from "./pages/articles/ShipEmissionsArticle";
import USRestockingArticle from "./pages/articles/USRestockingArticle";

import AirFreightArticle from "./pages/articles/AirFreightArticle";
import SuezCanalArticle from "./pages/articles/SuezCanalArticle";
import AGVMarketArticle from "./pages/articles/AGVMarketArticle";
import ChineseEcommerceArticle from "./pages/articles/ChineseEcommerceArticle";
import SupplyChainWeatherArticle from "./pages/articles/SupplyChainWeatherArticle";
import EuropeLogisticsArticle from "./pages/articles/EuropeLogisticsArticle";
import JDEuropeArticle from "./pages/articles/JDEuropeArticle";
import WarehouseAIArticle from "./pages/articles/WarehouseAIArticle";
import Prologis2026Article from "./pages/articles/Prologis2026Article";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <HashRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/article/freight-rates" element={<FreightRatesArticle />} />
            <Route path="/article/train-connection" element={<TrainConnectionArticle />} />
            <Route path="/article/carbon-market" element={<CarbonMarketArticle />} />
            <Route path="/article/aws-outage" element={<AWSOutageArticle />} />
            <Route path="/article/port-strikes" element={<PortStrikesArticle />} />
            <Route path="/article/cosco-boxship" element={<COSCOBoxshipArticle />} />
            <Route path="/article/cosco-shipping" element={<COSCOShippingArticle />} />
            <Route path="/article/sf-express-uk" element={<SFExpressUKArticle />} />
            <Route path="/article/china-eu-rail" element={<ChinaEURailFreightArticle />} />
            <Route path="/article/cma-cgm-suez" element={<CMAGMSuezArticle />} />
            <Route path="/article/ups-kuehne" element={<UPSKuehneArticle />} />
            <Route path="/article/amazon-netherlands" element={<AmazonNetherlandsArticle />} />
            <Route path="/article/alibaba-liege" element={<AlibabaLiegeArticle />} />
            <Route path="/article/inpost-iberia" element={<InPostIberiaArticle />} />
            <Route path="/article/eurocommerce-tax" element={<EuroCommerceTaxArticle />} />
            <Route path="/article/monthly-logistics-insights" element={<MonthlyLogisticsInsightsArticle />} />
            <Route path="/article/figure-bmw" element={<FigureBMWArticle />} />
            <Route path="/article/europe-etruck" element={<EuropeTruckArticle />} />
            <Route path="/article/dhl-halle" element={<DHLHalleArticle />} />
            <Route path="/article/efti-digital" element={<EFTIDigitalArticle />} />
            <Route path="/article/emirates-vtol" element={<EmiratesVTOLArticle />} />
            <Route path="/article/asian-investment" element={<AsianInvestmentArticle />} />
            <Route path="/article/mckinsey-ai" element={<McKinseyAIArticle />} />
            <Route path="/article/belgium-strikes" element={<BelgiumStrikesArticle />} />
            <Route path="/article/prologis-microgrid" element={<PrologisMicrogridArticle />} />
            <Route path="/article/red-sea-update" element={<RedSeaUpdateArticle />} />
            <Route path="/article/ship-emissions" element={<ShipEmissionsArticle />} />
            <Route path="/article/us-restocking" element={<USRestockingArticle />} />

            <Route path="/article/air-freight" element={<AirFreightArticle />} />
            <Route path="/article/suez-canal" element={<SuezCanalArticle />} />
            <Route path="/article/agv-market" element={<AGVMarketArticle />} />
            <Route path="/article/chinese-ecommerce" element={<ChineseEcommerceArticle />} />
            <Route path="/article/supply-chain-weather" element={<SupplyChainWeatherArticle />} />
            <Route path="/article/europe-logistics" element={<EuropeLogisticsArticle />} />
            <Route path="/article/jd-europe" element={<JDEuropeArticle />} />
            <Route path="/article/warehouse-ai" element={<WarehouseAIArticle />} />
            <Route path="/article/prologis-2026" element={<Prologis2026Article />} />

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </HashRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;